import gql from "graphql-tag";
import InvoiceThemeService from "../../../backend/src/common/invoiceTheme/invoiceThemeService";
import { apolloClient } from "@/apollo.services";

export default class InvoiceThemeFrontService extends InvoiceThemeService {
    // TODO rename to InvoiceThemeServiceFront

    setObjInfoFromEl(obj, el) {
        if (!el || !obj) {
            return obj;
        }
        obj.offsetHeight = el.offsetHeight;
        obj.offsetWidth = el.offsetWidth;
        obj.el = el;

        const computedStyle = window.getComputedStyle(el);

        // console.log("el.getBoundingClientRect()", el.getBoundingClientRect())
        // obj.computedHeight = parseFloat(el.getBoundingClientRect().height)
        // obj.computedWidth = parseFloat(el.getBoundingClientRect().width)
        obj.marginTop = parseFloat(computedStyle.marginTop);
        obj.marginBottom = parseFloat(computedStyle.marginBottom);
        obj.marginLeft = parseFloat(computedStyle.marginLeft);
        obj.marginRight = parseFloat(computedStyle.marginRight);

        obj.paddingTop = parseFloat(computedStyle.paddingTop);
        obj.paddingBottom = parseFloat(computedStyle.paddingBottom);
        obj.paddingLeft = parseFloat(computedStyle.paddingLeft);
        obj.paddingRight = parseFloat(computedStyle.paddingRight);

        obj.verticalMargin = obj.marginTop + obj.marginBottom;
        obj.horizontalMargin = obj.marginLeft + obj.marginRight;
        obj.verticalPadding = obj.paddingTop + obj.paddingBottom;
        obj.horizontalPadding = obj.paddingLeft + obj.paddingRight;

        obj.fullSpaceHeight = obj.offsetHeight + obj.verticalMargin; // vertical space occupied, including margins
        obj.fullSpaceWidth = obj.offsetWidth + obj.horizontalMargin; // horizontal space occupied, including margins

        return obj;
    }

    setObjInfoFromEl2(obj, el) {
        if (!el || !obj) {
            return obj;
        }
        obj.offsetHeight = el.offsetHeight;
        obj.offsetWidth = el.offsetWidth;
        obj.el = el;
        obj.computedHeight = parseFloat(window.getComputedStyle(el).height);
        obj.computedWidth = parseFloat(window.getComputedStyle(el).width);
        // obj.height = obj.offsetHeight || obj.computedHeight || 0
        // obj.width = obj.offsetWidth || obj.computedWidth || 0
        obj.marginTop = parseFloat(window.getComputedStyle(el).marginTop);
        obj.marginBottom = parseFloat(window.getComputedStyle(el).marginBottom);
        obj.marginLeft = parseFloat(window.getComputedStyle(el).marginLeft);
        obj.marginRight = parseFloat(window.getComputedStyle(el).marginRight);

        obj.paddingTop = parseFloat(window.getComputedStyle(el).paddingTop);
        obj.paddingBottom = parseFloat(window.getComputedStyle(el).paddingBottom);
        obj.paddingLeft = parseFloat(window.getComputedStyle(el).paddingLeft);
        obj.paddingRight = parseFloat(window.getComputedStyle(el).paddingRight);

        obj.verticalMargin = obj.marginTop + obj.marginBottom;
        obj.horizontalMargin = obj.marginLeft + obj.marginRight;
        obj.verticalPadding = obj.paddingTop + obj.paddingBottom;
        obj.horizontalPadding = obj.paddingLeft + obj.paddingRight;

        obj.fullSpaceHeight = obj.offsetHeight + obj.verticalMargin; // vertical space occupied, including margins
        obj.fullSpaceWidth = obj.offsetWidth + obj.horizontalMargin; // horizontal space occupied, including margins

        return obj;
    }

    extractPageSizeInfoFromDom(invoicePageRef, renderingInfo) {
        if (!invoicePageRef) {
            return null;
        }

        // InvoiceThemeService.setObjInfoFromEl(renderingInfo.document, invoicePageRef)
        const pageEl = invoicePageRef.querySelector("#fullPage");
        this.setObjInfoFromEl(renderingInfo.page, pageEl);

        for (const [k, v] of Object.entries(renderingInfo)) {
            const obj = v as any;
            const id = obj.id;
            const el = invoicePageRef.querySelector(id);
            if (!el) {
                continue;
            }
            if (id !== "#mainTableBlock") {
                this.setObjInfoFromEl(obj, el);
            } else {
                const thead = el.querySelector("thead");
                const tbody = el.querySelector("tbody");
                const tfoot = el.querySelector("tfoot");

                this.setObjInfoFromEl(obj, el);

                this.setObjInfoFromEl(obj.thead, thead);

                this.setObjInfoFromEl(obj.tfoot, tfoot);

                this.setObjInfoFromEl(obj.tbody, tbody);

                const rows = tbody.querySelectorAll("tr");
                obj.tbody.rows = []; // Empty list first
                for (const row of rows) {
                    const rowObj = { id: row.id };
                    obj.tbody.rows.push(this.setObjInfoFromEl(rowObj, row));
                }
            }
        }
        return renderingInfo;
    }

    static async fetchDefaultBackgrounds(keys: string[]) {
        const response = await apolloClient.query({
            query: gql`
                query ($keys: [String]!) {
                    getDefaultBackgrounds(data: { keys: $keys }) {
                        fileKey
                        signedUrl
                    }
                }
            `,
            variables: {
                keys,
            },
        });
        return response.data?.getDefaultBackgrounds;
    }

    static async fetchDefaultBackground(key: string) {
        const response = await this.fetchDefaultBackgrounds([key]);
        return response ? response[0] : null;
    }

    static getSampleInvoiceAndQuotation(type) {
        if (!invoiceSamples?.[type]) {
            return null;
        }
        return {
            invoice: invoiceSamples[type],
            quotation: invoiceQuotations[type],
        };
    }
}

export const previewDefaultCompany = {
    __typename: "Company",
    id: "Exxxxxxxxxxxxxxxxxxxxxxxx",
    name: "Tech Solutions Innovantes",
    address: "45 Avenue des Champs-Élysées",
    postalCode: "75008",
    city: "Paris",
    country: "France",
    siret: "09876543210987",
    siren: "098765432",
    vatNumber: "FR09876543210",
};

export const previewDefaultClient = {
    __typename: "Company",
    id: "Dxxxxxxxxxxxxxxxxxxxxxxxx",
    name: "Mon client",
    address: "123 Rue de la République",
    postalCode: "75001",
    city: "Paris",
    country: "France",
    siret: "01234567890123",
    siren: "012345678",
    vatNumber: "FR01234567890",
    isActive: true,
};

export const previewReceiver = {
    email: "email.client@exemple.fr",
    lastname: "",
    firstname: "",
    phoneNumber: "+33612345678",
};

export const invoiceSamples = {
    Facture: {
        __typename: "Invoice",
        id: "clyd2dq480000nb1oy9vq396o",
        type: "INVOICE",
        title: "Prestations diverses",
        additionalComment: null,
        internalComment: null,
        number: "FACTURE-202407-0000046",
        receivers: null,
        status: "VALIDATED",
        date: "2024-07-08T00:00:00.000Z",
        dueDate: "2024-08-08T00:00:00.000Z",
        paymentTerms: null,
        paymentDetails: null,
        periodicity: null,
        nextDate: null,
        startDate: null,
        vatType: "NO_VAT_TYPE",
        endDate: null,
        dueDateUnitOfTime: null,
        dueDateAmount: null,
        legalText: null,
        creditNoteOf: null,
        creditNotes: [],
        company: previewDefaultCompany,
        client: previewDefaultClient,
        lines: [
            {
                __typename: "InvoiceLine",
                id: "clyd2wxvu000lnb1oi2iiiep0",
                type: "PRODUCT",
                reference: "PROD006",
                title: "Lorem ipsum odor amet",
                description: "",
                quantity: 1,
                unitPrice: 100,
                netAmount: 100,
                grossAmount: 105.5,
                vatAmount: 5.5,
                vatRate: 5.5,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "ckpweg23oeiup0842jt41fjmr",
                    description: null,
                    percentage: null,
                    accountableAccount: null,
                },
                expand: false,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clyd2wxvu000mnb1o9710cusl",
                type: "PRODUCT",
                reference: "PROD007",
                title: "Consectetuer adipiscing elit",
                description: "",
                quantity: 1,
                unitPrice: 4,
                netAmount: 4,
                grossAmount: 4.8,
                vatAmount: 0.8,
                vatRate: 20,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "ck9827htaum9c07303m2ndi39",
                    description: null,
                    percentage: null,
                    accountableAccount: null,
                },
                expand: false,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clyd2wxvu000nnb1odfwqy6o4",
                type: "PRODUCT",
                reference: "PROD008",
                title: "Aenean commodo ligula eget dolor",
                description: "Consectetuer adipiscing elit, consectetuer adipiscing elit",
                quantity: 1,
                unitPrice: 10,
                netAmount: 10,
                grossAmount: 10.21,
                vatAmount: 0.21,
                vatRate: 2.1,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clu752jz00001ue6w9j6i8yib",
                    description: "test",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
                expand: true,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clyd2wxvu000onb1ok3kn5plw",
                type: "PRODUCT",
                reference: "PROD009",
                title: "Cum sociis natoque penatibu",
                description: "Lorem ipsum odor amet, lorem ligula eget dolor",
                quantity: 4,
                unitPrice: 100,
                netAmount: 400,
                grossAmount: 480,
                vatAmount: 80,
                vatRate: 20,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clu7536od0002ue6wenk1hcdt",
                    description: "er",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
                expand: true,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clyd2wxvu000pnb1oq6de2w7g",
                type: "PRODUCT",
                reference: "PROD010",
                title: "Donec pede justo",
                description: "",
                quantity: 3,
                unitPrice: 2,
                netAmount: 6,
                grossAmount: 6,
                vatAmount: 0,
                vatRate: 0,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clxsyagpc00wjfjyp5dpbo23w",
                    description: "",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
                expand: false,
                discountType: "%",
            },
        ],
        document: {
            __typename: "Document",
            id: "clyd2i0c20000cfv5513gt02m",
        },
        signedUrl: "",
        autoValidation: null,
        sendEmailAfterValidation: null,
        data: {
            legalText:
                "Pixello Agency au capital social de 1000 € - 91 RUE DU DOCTEUR SUREAU 93160 NOISY LE GRAND - RCS AGEN 841097223 - APE 6201Z - TVA Intracommunautaire FR29841097223",
            paymentDetails:
                "Le règlement anticipé ne donne pas lieu à escompte. En cas de règlement tardif, il sera appliqué un intérêt égal à 3 fois le taux légal.\n\nOutre des pénalités de retard déjà prévues par la loi, une indemnité forfaitaire pour frais de recouvrement de 40 euros sera appliquée.",
            additionalComment: "",
            internalComment: "",
            receivers: [previewReceiver],
        },
        depositOf: null,
        deposits: [],
        discount: null,
        discountPercentage: null,
        tags: [],
    },
    FactureAvecAcomptes: {
        __typename: "Invoice",
        id: "",
        type: "INVOICE",
        title: "Prestations diverses",
        additionalComment: null,
        internalComment: null,
        number: "FACTURE-203409-0000074",
        receivers: null,
        status: "VALIDATED",
        date: "2024-07-08T00:00:00.000Z",
        dueDate: "2024-08-08T00:00:00.000Z",
        paymentTerms: null,
        paymentDetails: null,
        periodicity: null,
        nextDate: null,
        startDate: null,
        vatType: "NO_VAT_TYPE",
        endDate: null,
        dueDateUnitOfTime: null,
        dueDateAmount: null,
        legalText: null,
        creditNoteOf: null,
        creditNotes: [],
        company: previewDefaultCompany,
        client: previewDefaultClient,
        lines: [
            {
                __typename: "InvoiceLine",
                id: "clyy8o7z5000ce0jcv9yu8ozf",
                type: "PRODUCT",
                reference: "PROD006",
                title: "Lorem ipsum odor amet",
                description: "",
                quantity: 1,
                unitPrice: 100,
                netAmount: 100,
                grossAmount: 105.5,
                vatAmount: 5.5,
                vatRate: 5.5,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "ckpweg23oeiup0842jt41fjmr",
                    description: null,
                    percentage: null,
                    accountableAccount: null,
                },
                expand: false,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clyy8o7z5000de0jcfzyefyie",
                type: "PRODUCT",
                reference: "PROD007",
                title: "Consectetuer adipiscing elit",
                description: "",
                quantity: 1,
                unitPrice: 4,
                netAmount: 4,
                grossAmount: 4.8,
                vatAmount: 0.8,
                vatRate: 20,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "ck9827htaum9c07303m2ndi39",
                    description: null,
                    percentage: null,
                    accountableAccount: null,
                },
                expand: false,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clyy8o7z6000ee0jc938ydb05",
                type: "PRODUCT",
                reference: "PROD008",
                title: "Aenean commodo ligula eget dolor",
                description: "Consectetuer adipiscing elit, consectetuer adipiscing elit",
                quantity: 1,
                unitPrice: 10,
                netAmount: 10,
                grossAmount: 10.21,
                vatAmount: 0.21,
                vatRate: 2.1,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clu752jz00001ue6w9j6i8yib",
                    description: "test",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
                expand: true,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clyy8o7z6000fe0jch1sw3bzi",
                type: "PRODUCT",
                reference: "PROD009",
                title: "Cum sociis natoque penatibu",
                description: "",
                quantity: 4,
                unitPrice: 100,
                netAmount: 400,
                grossAmount: 480,
                vatAmount: 80,
                vatRate: 20,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clu7536od0002ue6wenk1hcdt",
                    description: "er",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
                expand: true,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clyy8o7z6000ge0jcbbxzr11m",
                type: "PRODUCT",
                reference: "PROD010",
                title: "Donec pede justo",
                description: "",
                quantity: 3,
                unitPrice: 2,
                netAmount: 6,
                grossAmount: 6,
                vatAmount: 0,
                vatRate: 0,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clxsyagpc00wjfjyp5dpbo23w",
                    description: "",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
                expand: false,
                discountType: "%",
            },
        ],
        document: {
            __typename: "Document",
            id: "clyy8moe50000pkttkrchwvlr",
        },
        signedUrl: "",
        autoValidation: null,
        sendEmailAfterValidation: null,
        data: {
            legalText:
                "Pixello Agency au capital social de 1000 € - 91 RUE DU DOCTEUR SUREAU 93160 NOISY LE GRAND - RCS AGEN 841097223 - APE 6201Z - TVA Intracommunautaire FR29841097223",
            paymentDetails:
                "Le règlement anticipé ne donne pas lieu à escompte. En cas de règlement tardif, il sera appliqué un intérêt égal à 3 fois le taux légal.\n\nOutre des pénalités de retard déjà prévues par la loi, une indemnité forfaitaire pour frais de recouvrement de 40 euros sera appliquée.",
            additionalComment: "",
            internalComment: "",
            receivers: [previewReceiver],
            deposits: [
                {
                    date: "2024-07-08T00:00:00.000Z",
                    name: "Acompte 1 de la {{FACTURE-PROVISOIRE}}",
                    amount: 303.26,
                    percentage: 50,
                },
                {
                    date: "2024-08-08T02:00:00+02:00",
                    name: "Acompte 2 de la {{FACTURE-PROVISOIRE}}",
                    amount: 303.25,
                    percentage: 50,
                },
            ],
        },
        depositOf: null,
        deposits: [
            {
                __typename: "Invoice",
                id: "clyy8mecy0007e0jcqc9d4fxv",
                title: "Acompte 1 de la FACTURE-202401-0000001",
                date: "2024-07-08T00:00:00.000Z",
                status: "VALIDATED",
                grossAmount: 303.26,
            },
            {
                __typename: "Invoice",
                id: "clyy8medc000ae0jc2shu6x25",
                title: "Acompte 2 de la FACTURE-202401-0000001",
                date: "2024-08-08T00:00:00.000Z",
                status: "VALIDATED",
                grossAmount: 303.25,
            },
        ],
        discount: null,
        discountPercentage: null,
        tags: [],
    },

    Devis: {
        __typename: "Invoice",
        id: "clyd2dq480000nb1oy9vq396o",
        type: "QUOTATION",
        title: "Prestations diverses",
        additionalComment: null,
        internalComment: null,
        number: "FACTURE-202407-0000046",
        receivers: null,
        status: "VALIDATED",
        date: "2024-07-08T00:00:00.000Z",
        dueDate: "2024-08-08T00:00:00.000Z",
        paymentTerms: null,
        paymentDetails: null,
        periodicity: null,
        nextDate: null,
        startDate: null,
        vatType: "NO_VAT_TYPE",
        endDate: null,
        dueDateUnitOfTime: null,
        dueDateAmount: null,
        legalText: null,
        creditNoteOf: null,
        creditNotes: [],
        company: previewDefaultCompany,
        client: previewDefaultClient,
        lines: [
            {
                __typename: "InvoiceLine",
                id: "clyd2wxvu000lnb1oi2iiiep0",
                type: "PRODUCT",
                reference: "PROD006",
                title: "Lorem ipsum odor amet",
                description: "",
                quantity: 1,
                unitPrice: 100,
                netAmount: 100,
                grossAmount: 105.5,
                vatAmount: 5.5,
                vatRate: 5.5,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "ckpweg23oeiup0842jt41fjmr",
                    description: null,
                    percentage: null,
                    accountableAccount: null,
                },
                expand: false,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clyd2wxvu000mnb1o9710cusl",
                type: "PRODUCT",
                reference: "PROD007",
                title: "Consectetuer adipiscing elit",
                description: "",
                quantity: 1,
                unitPrice: 4,
                netAmount: 4,
                grossAmount: 4.8,
                vatAmount: 0.8,
                vatRate: 20,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "ck9827htaum9c07303m2ndi39",
                    description: null,
                    percentage: null,
                    accountableAccount: null,
                },
                expand: false,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clyd2wxvu000nnb1odfwqy6o4",
                type: "PRODUCT",
                reference: "PROD008",
                title: "Aenean commodo ligula eget dolor",
                description: "Consectetuer adipiscing elit, consectetuer adipiscing elit",
                quantity: 1,
                unitPrice: 10,
                netAmount: 10,
                grossAmount: 10.21,
                vatAmount: 0.21,
                vatRate: 2.1,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clu752jz00001ue6w9j6i8yib",
                    description: "test",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
                expand: true,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clyd2wxvu000onb1ok3kn5plw",
                type: "PRODUCT",
                reference: "PROD009",
                title: "Cum sociis natoque penatibu",
                description: "Lorem ipsum odor amet, lorem ligula eget dolor",
                quantity: 4,
                unitPrice: 100,
                netAmount: 400,
                grossAmount: 480,
                vatAmount: 80,
                vatRate: 20,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clu7536od0002ue6wenk1hcdt",
                    description: "er",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
                expand: true,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clyd2wxvu000pnb1oq6de2w7g",
                type: "PRODUCT",
                reference: "PROD010",
                title: "Donec pede justo",
                description: "",
                quantity: 3,
                unitPrice: 2,
                netAmount: 6,
                grossAmount: 6,
                vatAmount: 0,
                vatRate: 0,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clxsyagpc00wjfjyp5dpbo23w",
                    description: "",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
                expand: false,
                discountType: "%",
            },
        ],
        document: {
            __typename: "Document",
            id: "clyd2i0c20000cfv5513gt02m",
        },
        signedUrl: "",
        autoValidation: null,
        sendEmailAfterValidation: null,
        data: {
            legalText:
                "Pixello Agency au capital social de 1000 € - 91 RUE DU DOCTEUR SUREAU 93160 NOISY LE GRAND - RCS AGEN 841097223 - APE 6201Z - TVA Intracommunautaire FR29841097223",
            paymentDetails:
                "Le règlement anticipé ne donne pas lieu à escompte. En cas de règlement tardif, il sera appliqué un intérêt égal à 3 fois le taux légal.\n\nOutre des pénalités de retard déjà prévues par la loi, une indemnité forfaitaire pour frais de recouvrement de 40 euros sera appliquée.",
            additionalComment: "",
            internalComment: "",
            receivers: [previewReceiver],
        },
        depositOf: null,
        deposits: [],
        discount: null,
        discountPercentage: null,
        tags: [],
    },

    Acompte: {
        __typename: "Invoice",
        id: "clyy8medc000ae0jc2shu6x25",
        type: "INVOICE",
        title: "Acompte 2 de la FACTURE-202401-0000001",
        additionalComment: null,
        internalComment: null,
        number: "AC-202408-0000002",
        receivers: null,
        status: "VALIDATED",
        date: "2024-08-08T00:00:00.000Z",
        dueDate: "2024-08-08T00:00:00.000Z",
        paymentTerms: null,
        paymentDetails: null,
        periodicity: null,
        nextDate: null,
        startDate: null,
        vatType: null,
        endDate: null,
        dueDateUnitOfTime: null,
        dueDateAmount: null,
        legalText: null,
        creditNoteOf: null,
        creditNotes: [],
        company: previewDefaultCompany,
        client: previewDefaultClient,
        lines: [
            {
                __typename: "InvoiceLine",
                id: "clz0ziepm0001qnvbnxs8c6ak",
                type: "DEPOSIT",
                reference: null,
                title: "Acompte 2 de la FACTURE-202401-0000001",
                description: "Acompte de la facture de 606,51 €",
                quantity: 1,
                unitPrice: null,
                netAmount: 259.995713178678,
                grossAmount: 303.25,
                vatAmount: 43.25428682132199,
                vatRate: null,
                discount: null,
                discountPercentage: null,
                product: null,
                expand: true,
                discountType: "%",
            },
        ],
        document: {
            __typename: "Document",
            id: "clz0zptep000012bcm0792nl6",
        },
        signedUrl: "",
        autoValidation: null,
        sendEmailAfterValidation: null,
        data: {
            legalText:
                "Pixello Agency au capital social de 1000 € - 91 RUE DU DOCTEUR SUREAU 93160 NOISY LE GRAND - RCS AGEN 841097223 - APE 6201Z - TVA Intracommunautaire FR29841097223",
            paymentDetails:
                "Le règlement anticipé ne donne pas lieu à escompte. En cas de règlement tardif, il sera appliqué un intérêt égal à 3 fois le taux légal.\n\nOutre des pénalités de retard déjà prévues par la loi, une indemnité forfaitaire pour frais de recouvrement de 40 euros sera appliquée.",
            additionalComment: "",
            internalComment: "",
            receivers: [previewReceiver],
        },
        depositOf: {
            __typename: "Invoice",
            id: "clyy8l3640000e0jcst0kdupl",
            title: "Prestations diverses",
            date: "2024-07-08T00:00:00.000Z",
            status: "VALIDATED",
            type: "INVOICE",
            grossAmount: 606.51,
            deposits: [
                {
                    __typename: "Invoice",
                    id: "clyy8mecy0007e0jcqc9d4fxv",
                    title: "Acompte 1 de la FACTURE-202401-0000001",
                    grossAmount: 303.26,
                    lines: [
                        {
                            __typename: "InvoiceLine",
                            id: "clyyddo8r0001deg5pbj82kx7",
                            grossAmount: 303.26,
                        },
                    ],
                },
                {
                    __typename: "Invoice",
                    id: "clyy8medc000ae0jc2shu6x25",
                    title: "Acompte 2 de la FACTURE-202401-0000001",
                    grossAmount: 303.25,
                    lines: [
                        {
                            __typename: "InvoiceLine",
                            id: "clz0ziepm0001qnvbnxs8c6ak",
                            grossAmount: 303.25,
                        },
                    ],
                },
            ],
        },
        deposits: [],
        discount: null,
        discountPercentage: null,
        tags: [],
    },

    Bordereau: {
        __typename: "Invoice",
        id: "clruqlwqd0003jx0a1yyv6p72",
        type: "BILL_DELIVERY",
        title: "aefaze",
        additionalComment: null,
        internalComment: null,
        number: "BL-202401-0000001",
        receivers: null,
        status: "VALIDATED",
        date: "2024-01-30T00:00:00.000Z",
        dueDate: "2024-01-30T00:00:00.000Z",
        paymentTerms: null,
        paymentDetails:
            "Le règlement anticipé ne donne pas lieu à escompte. En cas de règlement tardif, il sera appliqué un intérêt égal à 3 fois le taux légal.\n\nOutre des pénalités de retard déjà prévues par la loi, une indemnité forfaitaire pour frais de recouvrement de 40 euros sera appliquée.",
        periodicity: null,
        nextDate: null,
        startDate: null,
        vatType: null,
        endDate: null,
        dueDateUnitOfTime: null,
        dueDateAmount: null,
        legalText:
            "Pixello Agency au capital social de 1000 € - 91 RUE DU DOCTEUR SUREAU 93160 NOISY LE GRAND - RCS AGEN 841097223 - APE 6201Z - TVA Intracommunautaire FR29841097223",
        creditNoteOf: null,
        creditNotes: [],
        company: previewDefaultCompany,
        client: previewDefaultClient,
        lines: [
            {
                __typename: "InvoiceLine",
                id: "clsbv3ewq0002le0aosz6ias7",
                type: "PRODUCT",
                reference: "PROD006",
                title: "Lorem ipsum odor amet",
                description: "",
                quantity: 1,
                unitPrice: 12,
                netAmount: 12,
                grossAmount: 14.4,
                vatAmount: 2.4,
                vatRate: 20,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "ck97f53hhria30730t88ztmek",
                    description: null,
                    percentage: null,
                    accountableAccount: null,
                },
                expand: false,
                discountType: "%",
            },
        ],
        document: null,
        signedUrl: "",
        autoValidation: null,
        sendEmailAfterValidation: null,
        data: {
            legalText:
                "Pixello Agency au capital social de 1000 € - 91 RUE DU DOCTEUR SUREAU 93160 NOISY LE GRAND - RCS AGEN 841097223 - APE 6201Z - TVA Intracommunautaire FR29841097223",
            paymentDetails:
                "Le règlement anticipé ne donne pas lieu à escompte. En cas de règlement tardif, il sera appliqué un intérêt égal à 3 fois le taux légal.\n\nOutre des pénalités de retard déjà prévues par la loi, une indemnité forfaitaire pour frais de recouvrement de 40 euros sera appliquée.",
            additionalComment: "",
            internalComment: "",
            receivers: [previewReceiver],
        },
        depositOf: null,
        deposits: [],
        discount: null,
        discountPercentage: null,
        tags: [],
    },
    FactureAvecRemises: {
        __typename: "Invoice",
        id: "clziltqt30003ynx7lnnybj8v",
        type: "INVOICE",
        title: "Prestations diverses",
        additionalComment: null,
        internalComment: null,
        number: "FACTURE-202407-0000053",
        receivers: null,
        status: "VALIDATED",
        date: "2024-07-08T00:00:00.000Z",
        dueDate: "2024-08-08T00:00:00.000Z",
        paymentTerms: null,
        paymentDetails: null,
        periodicity: null,
        nextDate: null,
        startDate: null,
        vatType: "NO_VAT_TYPE",
        endDate: null,
        dueDateUnitOfTime: null,
        dueDateAmount: null,
        legalText: null,
        creditNoteOf: null,
        creditNotes: [],
        company: previewDefaultCompany,
        client: previewDefaultClient,
        lines: [
            {
                __typename: "InvoiceLine",
                id: "clzimg09u0000y1a303een02o",
                type: "PRODUCT",
                reference: "PROD007",
                title: "Consectetuer adipiscing elit",
                description: "",
                quantity: 1,
                unitPrice: 100,
                netAmount: 100,
                grossAmount: 105.5,
                vatAmount: 5.5,
                vatRate: 5.5,
                discount: null,
                discountPercentage: 10,
                product: {
                    __typename: "InvoiceProduct",
                    id: "ckpweg23oeiup0842jt41fjmr",
                    description: null,
                    percentage: null,
                    accountableAccount: null,
                },
                expand: false,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clzimg09v0001y1a3huvum601",
                type: "PRODUCT",
                reference: "PROD008",
                title: "Aenean commodo ligula eget dolor",
                description: "Consectetuer adipiscing elit, consectetuer adipiscing elit",
                quantity: 1,
                unitPrice: 4,
                netAmount: 4,
                grossAmount: 4.8,
                vatAmount: 0.8,
                vatRate: 20,
                discount: null,
                discountPercentage: 5,
                product: {
                    __typename: "InvoiceProduct",
                    id: "ck9827htaum9c07303m2ndi39",
                    description: null,
                    percentage: null,
                    accountableAccount: null,
                },
                expand: false,
                discountType: "%",
            },
            {
                __typename: "InvoiceLine",
                id: "clzimg09v0002y1a3jbf5n5yp",
                type: "PRODUCT",
                reference: "PROD009",
                title: "Cum sociis natoque penatibu",
                description: "Lorem ipsum odor amet, lorem ligula eget dolor",
                quantity: 1,
                unitPrice: 10,
                netAmount: 10,
                grossAmount: 10.21,
                vatAmount: 0.21,
                vatRate: 2.1,
                discount: 1,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clu752jz00001ue6w9j6i8yib",
                    description: "test",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
                expand: true,
                discountType: "€",
            },
            {
                __typename: "InvoiceLine",
                id: "clzimg09v0003y1a3rda3dktx",
                type: "PRODUCT",
                reference: "PROD010",
                title: "Donec pede justo",
                description: "",
                quantity: 4,
                unitPrice: 100,
                netAmount: 400,
                grossAmount: 480,
                vatAmount: 80,
                vatRate: 20,
                discount: 20,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clu7536od0002ue6wenk1hcdt",
                    description: "er",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
                expand: true,
                discountType: "€",
            },
            {
                __typename: "InvoiceLine",
                id: "clzimg09v0004y1a3ick1u2xi",
                type: "PRODUCT",
                reference: "PROD011",
                title: "Lorem ipsum odor amet",
                description: "",
                quantity: 3,
                unitPrice: 2,
                netAmount: 6,
                grossAmount: 6,
                vatAmount: 0,
                vatRate: 0,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clxsyagpc00wjfjyp5dpbo23w",
                    description: "",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
                expand: false,
                discountType: "%",
            },
        ],
        document: {
            __typename: "Document",
            id: "clzimkpmh0000qvadjiquvsf7",
        },
        signedUrl: "",
        autoValidation: null,
        sendEmailAfterValidation: null,
        data: {
            legalText:
                "Pixello Agency au capital social de 1000 € - 91 RUE DU DOCTEUR SUREAU 93160 NOISY LE GRAND - RCS AGEN 841097223 - APE 6201Z - TVA Intracommunautaire FR29841097223",
            paymentDetails:
                "Le règlement anticipé ne donne pas lieu à escompte. En cas de règlement tardif, il sera appliqué un intérêt égal à 3 fois le taux légal.\n\nOutre des pénalités de retard déjà prévues par la loi, une indemnité forfaitaire pour frais de recouvrement de 40 euros sera appliquée.",
            additionalComment: "",
            internalComment: "",
            receivers: [previewReceiver],
        },
        depositOf: null,
        deposits: [],
        discount: null,
        discountPercentage: 5,
        tags: [],
    },
    InventaireStock: {
        type: "INVENTORY",
        title: "",
        company: previewDefaultCompany,
        lines: [
            {
                reference: "PROD006",
                title: "Lorem ipsum odor amet",
                id: "cm0ffji5e0001nt9241oqx01t",
                type: "Stock",
                depreciationId: "",
                father: false,
                indexer: 0,
                childOf: null,
                expand: false,
                show: true,
                invoiceProduct: {
                    title: "Tomate",
                    reference: "TOM",
                    id: "cloenrl8k0005smz9n8afe1kf",
                    type: "PRODUCT",
                },
                quantity: 3,
                totalAmount: 750,
                stockAmountSigned: 750,
                depreciatedAmountSigned: null,
                stockAccount: {
                    name: "-",
                    stockAccount: "-",
                    inventoryAccount: "-",
                    depreciationAccount: "-",
                    type: "EXPENSE",
                },
                grossAmount: 750,
            },
            {
                reference: "PROD007",
                title: "Consectetuer adipiscing elit",
                id: "cm0ffji5e0002nt92kj6hj0ad",
                type: "Stock",
                depreciationId: "",
                father: false,
                indexer: 1,
                childOf: null,
                expand: false,
                show: true,
                invoiceProduct: {
                    title: "Semence Tomate",
                    reference: "SEM-TOM-01",
                    id: "cloeuydvx000fsmy9txpy0244",
                    type: "EXPENSE",
                },
                quantity: 449.88,
                totalAmount: 344.908,
                stockAmountSigned: 344.908,
                depreciatedAmountSigned: null,
                stockAccount: {
                    name: "Matières premières",
                    stockAccount: "311000",
                    inventoryAccount: "603100",
                    depreciationAccount: "391000",
                    type: "EXPENSE",
                },
                grossAmount: 344.908,
            },
            {
                reference: "PROD008",
                title: "Aenean commodo ligula eget dolor",
                id: "cm0ffji5e0004nt92w31t3syw",
                type: "Stock",
                depreciationId: "",
                father: false,
                indexer: 2,
                childOf: null,
                expand: false,
                show: true,
                invoiceProduct: {
                    title: "Semence pomme de terre",
                    reference: "SEM-PDT-01",
                    id: "clofrsw0x0003smoef0vd126l",
                    type: "EXPENSE",
                },
                quantity: 299.976,
                totalAmount: 2133.82928,
                stockAmountSigned: 2133.82928,
                depreciatedAmountSigned: null,
                stockAccount: {
                    name: "Matières premières",
                    stockAccount: "311000",
                    inventoryAccount: "603100",
                    depreciationAccount: "391000",
                    type: "EXPENSE",
                },
                grossAmount: 2133.82928,
            },
            {
                reference: "PROD009",
                title: "Cum sociis natoque penatibu",
                id: "cm0ffji5f0005nt92hw5yogoj",
                type: "Stock",
                depreciationId: "",
                father: false,
                indexer: 3,
                childOf: null,
                expand: false,
                show: true,
                invoiceProduct: {
                    title: "Semence maïs",
                    reference: "SEM-MAI-01",
                    id: "clofrtx100004smoe59o8cagq",
                    type: "EXPENSE",
                },
                quantity: 219.982,
                totalAmount: 3809.784,
                stockAmountSigned: 3809.784,
                depreciatedAmountSigned: null,
                stockAccount: {
                    name: "Matières premières",
                    stockAccount: "311000",
                    inventoryAccount: "603100",
                    depreciationAccount: "391000",
                    type: "EXPENSE",
                },
                grossAmount: 3809.784,
            },
            {
                reference: "PROD010",
                title: "Donec pede justo",
                id: "cm0ffji5e0003nt92t57pyfz2",
                type: "Stock",
                depreciationId: "",
                father: false,
                indexer: 4,
                childOf: null,
                expand: false,
                show: true,
                invoiceProduct: {
                    title: "Engrais",
                    reference: "ENG-01",
                    id: "cloeuz4qn000gsmy9p8ilqka0",
                    type: "EXPENSE",
                },
                quantity: -107,
                totalAmount: 1500,
                stockAmountSigned: 1500,
                depreciatedAmountSigned: null,
                stockAccount: {
                    name: "Matières premières",
                    stockAccount: "311000",
                    inventoryAccount: "603100",
                    depreciationAccount: "391000",
                    type: "EXPENSE",
                },
                grossAmount: 1500,
            },
        ],
        signer: {
            __typename: "User",
            id: "clwfifu3nrfs0smz9mv9qqjx1",
            firstname: "John",
            lastname: "DOE",
        },
        paymentDetails:
            "Le règlement anticipé ne donne pas lieu à escompte. En cas de règlement tardif, il sera appliqué un intérêt égal à 3 fois le taux légal. Outre des pénalités de retard déjà prévues par la loi, une indemnité forfaitaire pour frais de recouvrement de 40 euros sera appliquée.",
        stockInventory: {
            __typename: "StockInventory",
            id: "cm0ffji5c0000nt926y7ruvo1",
            status: "EDITION",
            date: "2024-08-29T17:17:12.000Z",
            signer: {
                __typename: "User",
                id: "clwfifu3nrfs0smz9mv9qqjx1",
                firstname: "John",
                lastname: "DOE",
            },
            accountingClosing: null,
            accountingPeriod: null,
            lines: [
                {
                    __typename: "StockInventoryLine",
                    id: "cm0ffji5e0001nt9241oqx01t",
                    stockProduct: {
                        __typename: "InvoiceProduct",
                        id: "cloenrl8k0005smz9n8afe1kf",
                        reference: "PROD006",
                        title: "Lorem ipsum odor amet",
                        type: "PRODUCT",
                    },
                    quantity: 3,
                    unregisteredStockProduct: null,
                    storedAmountSigned: 750,
                    depreciatedAmountSigned: null,
                    accountableAccount: null,
                    inventoryChange: null,
                },
                {
                    __typename: "StockInventoryLine",
                    id: "cm0ffji5e0002nt92kj6hj0ad",
                    stockProduct: {
                        __typename: "InvoiceProduct",
                        id: "cloeuydvx000fsmy9txpy0244",
                        reference: "PROD007",
                        title: "Consectetuer adipiscing elit",
                        type: "EXPENSE",
                    },
                    quantity: 449.88,
                    unregisteredStockProduct: null,
                    storedAmountSigned: 344.908,
                    depreciatedAmountSigned: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        name: "311000",
                    },
                    inventoryChange: {
                        __typename: "AccountableAccount",
                        name: "603100",
                    },
                },
                {
                    __typename: "StockInventoryLine",
                    id: "cm0ffji5e0004nt92w31t3syw",
                    stockProduct: {
                        __typename: "InvoiceProduct",
                        id: "clofrsw0x0003smoef0vd126l",
                        reference: "PROD008",
                        title: "Aenean commodo ligula eget dolor",
                        type: "EXPENSE",
                    },
                    quantity: 299.976,
                    unregisteredStockProduct: null,
                    storedAmountSigned: 2133.82928,
                    depreciatedAmountSigned: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        name: "311000",
                    },
                    inventoryChange: {
                        __typename: "AccountableAccount",
                        name: "603100",
                    },
                },
                {
                    __typename: "StockInventoryLine",
                    id: "cm0ffji5f0005nt92hw5yogoj",
                    stockProduct: {
                        __typename: "InvoiceProduct",
                        id: "clofrtx100004smoe59o8cagq",
                        reference: "PROD009",
                        title: "Cum sociis natoque penatibu",
                        type: "EXPENSE",
                    },
                    quantity: 219.982,
                    unregisteredStockProduct: null,
                    storedAmountSigned: 3809.784,
                    depreciatedAmountSigned: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        name: "311000",
                    },
                    inventoryChange: {
                        __typename: "AccountableAccount",
                        name: "603100",
                    },
                },
                {
                    __typename: "StockInventoryLine",
                    id: "cm0ffji5e0003nt92t57pyfz2",
                    stockProduct: {
                        __typename: "InvoiceProduct",
                        id: "cloeuz4qn000gsmy9p8ilqka0",
                        reference: "PROD010",
                        title: "Donec pede justo",
                        type: "EXPENSE",
                    },
                    quantity: -107,
                    unregisteredStockProduct: null,
                    storedAmountSigned: 1500,
                    depreciatedAmountSigned: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        name: "311000",
                    },
                    inventoryChange: {
                        __typename: "AccountableAccount",
                        name: "603100",
                    },
                },
            ],
        },
    },
};

export const invoiceQuotations = {
    Facture: undefined,
    Acompte: {
        __typename: "Invoice",
        id: "clyy8l3640000e0jcst0kdupl",
        type: "INVOICE",
        title: "Prestations diverses",
        additionalComment: null,
        internalComment: null,
        number: "FACTURE-202407-0000052",
        receivers: null,
        status: "VALIDATED",
        date: "2024-07-08T00:00:00.000Z",
        dueDate: "2024-08-08T00:00:00.000Z",
        paymentTerms: null,
        paymentDetails: null,
        periodicity: null,
        nextDate: null,
        startDate: null,
        vatType: "NO_VAT_TYPE",
        endDate: null,
        dueDateUnitOfTime: null,
        dueDateAmount: null,
        legalText: null,
        creditNoteOf: null,
        creditNotes: [],
        company: previewDefaultCompany,
        client: previewDefaultClient,
        lines: [
            {
                __typename: "InvoiceLine",
                id: "clyy8o7z5000ce0jcv9yu8ozf",
                type: "PRODUCT",
                reference: "PROD006",
                title: "Lorem ipsum odor amet",
                description: "",
                quantity: 1,
                unitPrice: 100,
                netAmount: 100,
                grossAmount: 105.5,
                vatAmount: 5.5,
                vatRate: 5.5,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "ckpweg23oeiup0842jt41fjmr",
                    description: null,
                    percentage: null,
                    accountableAccount: null,
                },
            },
            {
                __typename: "InvoiceLine",
                id: "clyy8o7z5000de0jcfzyefyie",
                type: "PRODUCT",
                reference: "PROD007",
                title: "Consectetuer adipiscing elit",
                description: "",
                quantity: 1,
                unitPrice: 4,
                netAmount: 4,
                grossAmount: 4.8,
                vatAmount: 0.8,
                vatRate: 20,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "ck9827htaum9c07303m2ndi39",
                    description: null,
                    percentage: null,
                    accountableAccount: null,
                },
            },
            {
                __typename: "InvoiceLine",
                id: "clyy8o7z6000ee0jc938ydb05",
                type: "PRODUCT",
                reference: "PROD008",
                title: "Aenean commodo ligula eget dolor",
                quantity: 1,
                unitPrice: 10,
                netAmount: 10,
                grossAmount: 10.21,
                vatAmount: 0.21,
                vatRate: 2.1,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clu752jz00001ue6w9j6i8yib",
                    description: "test",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
            },
            {
                __typename: "InvoiceLine",
                id: "clyy8o7z6000fe0jch1sw3bzi",
                type: "PRODUCT",
                reference: "PROD009",
                title: "Cum sociis natoque penatibu",
                description: "Lorem ipsum odor amet, lorem ligula eget dolor",
                quantity: 4,
                unitPrice: 100,
                netAmount: 400,
                grossAmount: 480,
                vatAmount: 80,
                vatRate: 20,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clu7536od0002ue6wenk1hcdt",
                    description: "er",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
            },
            {
                __typename: "InvoiceLine",
                id: "clyy8o7z6000ge0jcbbxzr11m",
                type: "PRODUCT",
                reference: "PROD010",
                title: "Donec pede justo",
                description: "",
                quantity: 3,
                unitPrice: 2,
                netAmount: 6,
                grossAmount: 6,
                vatAmount: 0,
                vatRate: 0,
                discount: null,
                discountPercentage: null,
                product: {
                    __typename: "InvoiceProduct",
                    id: "clxsyagpc00wjfjyp5dpbo23w",
                    description: "",
                    percentage: null,
                    accountableAccount: {
                        __typename: "AccountableAccount",
                        id: "clrcb6kgk007psmj8yltiltla",
                        name: "706",
                    },
                },
            },
        ],
        document: {
            __typename: "Document",
            id: "clyy8moe50000pkttkrchwvlr",
        },
        signedUrl: "",
        autoValidation: null,
        sendEmailAfterValidation: null,
        data: {
            deposits: [
                {
                    date: "2024-07-08T00:00:00.000Z",
                    name: "Acompte 1 de la {{FACTURE-PROVISOIRE}}",
                    amount: 303.26,
                    percentage: 50,
                },
                {
                    date: "2024-08-08T02:00:00+02:00",
                    name: "Acompte 2 de la {{FACTURE-PROVISOIRE}}",
                    amount: 303.25,
                    percentage: 50,
                },
            ],
            legalText:
                "Pixello Agency au capital social de 1000 € - 91 RUE DU DOCTEUR SUREAU 93160 NOISY LE GRAND - RCS AGEN 841097223 - APE 6201Z - TVA Intracommunautaire FR29841097223",
            receivers: [previewReceiver],
            paymentDetails:
                "Le règlement anticipé ne donne pas lieu à escompte. En cas de règlement tardif, il sera appliqué un intérêt égal à 3 fois le taux légal.\n\nOutre des pénalités de retard déjà prévues par la loi, une indemnité forfaitaire pour frais de recouvrement de 40 euros sera appliquée.",
            internalComment: "",
            additionalComment: "",
        },
        depositOf: null,
        deposits: [
            {
                __typename: "Invoice",
                id: "clyy8mecy0007e0jcqc9d4fxv",
                title: "Acompte 1 de la FACTURE-202401-0000001",
                date: "2024-07-08T00:00:00.000Z",
                status: "VALIDATED",
                grossAmount: 303.26,
            },
            {
                __typename: "Invoice",
                id: "clyy8medc000ae0jc2shu6x25",
                title: "Acompte 2 de la FACTURE-202401-0000001",
                date: "2024-08-08T00:00:00.000Z",
                status: "VALIDATED",
                grossAmount: 303.25,
            },
        ],
        discount: null,
        discountPercentage: null,
        tags: [],
    },
    Devis: undefined,
    Bordereau: undefined,
    InventaireStock: undefined,
};
